export const JOB_STATUS = {
  ACTIVE: 'active',
  DRAFT: 'draft',
  CLOSED: 'closed',
}
